import { connect } from "react-redux";
import * as commonActions from "store/common";
import * as selectors from "store/selectors";

import AppLayout from "./AppLayout";

const mapStateToProps = state => ({
  marginLayout: selectors.getMarginLayout(state),
});

const mapDispatchToProps = dispatch => ({
  saveHeight: height => dispatch(commonActions.saveHeight(height)),
  showError: () => dispatch(commonActions.showError()),
  checkMobileLayout: (isIOS, height) => dispatch(commonActions.checkMobileLayout(isIOS, height)),
  saveMobileLayout: height => dispatch(commonActions.saveMobileLayout(height)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
